import { Pipe, PipeTransform } from '@angular/core';
import {
  format,
  formatDistanceToNow,
  isToday,
  isYesterday,
  differenceInDays
} from 'date-fns';
import { isNilOrEmpty } from 'helpers';

@Pipe({ name: 'activityDateTime' })
export class ActivityDateTimePipe implements PipeTransform {
  transform(value: any): string {
    if (isNilOrEmpty(value)) {
      return null;
    }

    try {
      const date = new Date(value);
      const now = new Date();
      const daysAgo = differenceInDays(now, date);

      if (isToday(date)) {
        return formatDistanceToNow(date, { addSuffix: true });
      }

      if (isYesterday(date)) {
        return `Yesterday at ${format(date, 'p')}`;
      }

      if (daysAgo < 7) {
        return `${format(date, 'EEEE')} at ${format(date, 'p')}`;
      }

      return `${format(date, 'MMM d')} at ${format(date, 'p')}`;
    } catch (e) {
      console.error(e);
      return null;
    }
  }
}
